import { useQuery } from '@fv/client-core'

import { messagesQueryKeys } from '@/queryKeys'
import { carrierFetch } from '@/utils/carrierFetch'

import type { Message } from '../types'

async function fetchMessages(loadId: string) {
  return carrierFetch<Message[]>(`/loads/${loadId}/messages`)
}

export function useMessages({ loadId }: { loadId: string }) {
  return useQuery(messagesQueryKeys.load(loadId), () => fetchMessages(loadId), {
    enabled: Boolean(loadId),
  })
}
